import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { SupportService } from '../../../services/support.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
declare var $: any;

@Component({
    selector: 'app-support-new-standard',
    templateUrl: './support-new-standard.component.html',
    styleUrls: ['./support-new-standard.component.scss']
})
export class SupportNewStandardComponent implements OnInit {

    constructor(private route: ActivatedRoute,
        private router: Router, private supportService: SupportService,
        public authentication: AuthenticationService,
        private common: CommonService) { }

    pagecode: string = "supp-submit-std";
    module: string = "support";
    accessdenied: boolean = false;

    ngOnInit(): void {
    }

}
